module.exports = __webpack_public_path__ + "img/teacher.0f190a00.png";